// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeadProgressBar_container__zGu4L {
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 1100px;
  margin: 20px auto;
}

.LeadProgressBar_header__I8H1d {
  text-align: center;
  margin-bottom: 32px;
}

.LeadProgressBar_title__ZFY9f {
  font-size: 1.8rem;
  color: #1e40af;
  margin: 0 0 12px;
}

.LeadProgressBar_currentStage__n\\+P-a,
.LeadProgressBar_lastActivity__XeVa\\+ {
  font-size: 1.1rem;
  color: #374151;
  margin: 6px 0;
}

.LeadProgressBar_progressSection__j3\\+jd {
  margin-bottom: 40px;
}

.LeadProgressBar_progressBarWrapper__0nwfY {
  background: #f3f4f6;
  border-radius: 999px;
  height: 28px;
  overflow: hidden;
}

.LeadProgressBar_progressBar__BPONC {
  height: 100%;
  background: #e5e7eb;
  position: relative;
}

.LeadProgressBar_progressFill__SkEHR {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  transition: width 0.6s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.95rem;
}

.LeadProgressBar_progressText__64YYB {
  background: rgba(0, 0, 0, 0.25);
  padding: 4px 12px;
  border-radius: 999px;
}

.LeadProgressBar_progressLabel__P5s0K {
  text-align: center;
  margin-top: 12px;
  color: #4b5563;
  font-size: 0.95rem;
}

.LeadProgressBar_sectionTitle__qfHIk {
  font-size: 1.35rem;
  color: #1e40af;
  margin: 0 0 16px;
  text-align: center;
}

.LeadProgressBar_stepsList__n\\+Kn7 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.LeadProgressBar_stepItem__XwJRd {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 12px;
  border-radius: 8px;
  background: #f9fafb;
}

.LeadProgressBar_stepItem__XwJRd.LeadProgressBar_completed__JIYCv {
  background: #ecfdf5;
}

.LeadProgressBar_stepCircle__zi3Gr {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #d1d5db;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.LeadProgressBar_stepItem__XwJRd.LeadProgressBar_completed__JIYCv .LeadProgressBar_stepCircle__zi3Gr {
  background: #10b981;
}

.LeadProgressBar_stepContent__bL2qx {
  flex: 1 1;
}

.LeadProgressBar_stepLabel__Gt-35 {
  font-weight: 600;
  color: #1f2937;
}

.LeadProgressBar_stepDate__6yAKk {
  font-size: 0.85rem;
  color: #6b7280;
  margin-top: 4px;
}

.LeadProgressBar_timeline__iHGZW {
  position: relative;
  padding-left: 32px;
}

.LeadProgressBar_timeline__iHGZW::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 14px;
  width: 4px;
  background: #e5e7eb;
}

.LeadProgressBar_timelineItem__4hmyU {
  position: relative;
  margin-bottom: 28px;
}

.LeadProgressBar_timelineDot__o7kBM {
  position: absolute;
  left: -32px;
  top: 6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #3b82f6;
  border: 4px solid #bfdbfe;
}

.LeadProgressBar_timelineContent__0F-CI {
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
  border-left: 4px solid #3b82f6;
}

.LeadProgressBar_timelineAction__2aR0D {
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 8px;
}

.LeadProgressBar_timelineRemark__zXkqo {
  color: #374151;
  margin-bottom: 8px;
}

.LeadProgressBar_timelineMeta__BmCZ- {
  font-size: 0.85rem;
  color: #6b7280;
}

.LeadProgressBar_loading__PsmxU,
.LeadProgressBar_error__ySGlQ,
.LeadProgressBar_noData__7QR9B {
  text-align: center;
  padding: 40px 0;
  color: #6b7280;
  font-style: italic;
}

.LeadProgressBar_error__ySGlQ {
  color: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/SalesPages/LeadProgressBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\n  padding: 24px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  max-width: 1100px;\n  margin: 20px auto;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.title {\n  font-size: 1.8rem;\n  color: #1e40af;\n  margin: 0 0 12px;\n}\n\n.currentStage,\n.lastActivity {\n  font-size: 1.1rem;\n  color: #374151;\n  margin: 6px 0;\n}\n\n.progressSection {\n  margin-bottom: 40px;\n}\n\n.progressBarWrapper {\n  background: #f3f4f6;\n  border-radius: 999px;\n  height: 28px;\n  overflow: hidden;\n}\n\n.progressBar {\n  height: 100%;\n  background: #e5e7eb;\n  position: relative;\n}\n\n.progressFill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #60a5fa);\n  transition: width 0.6s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 0.95rem;\n}\n\n.progressText {\n  background: rgba(0, 0, 0, 0.25);\n  padding: 4px 12px;\n  border-radius: 999px;\n}\n\n.progressLabel {\n  text-align: center;\n  margin-top: 12px;\n  color: #4b5563;\n  font-size: 0.95rem;\n}\n\n.sectionTitle {\n  font-size: 1.35rem;\n  color: #1e40af;\n  margin: 0 0 16px;\n  text-align: center;\n}\n\n.stepsList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.stepItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 12px;\n  border-radius: 8px;\n  background: #f9fafb;\n}\n\n.stepItem.completed {\n  background: #ecfdf5;\n}\n\n.stepCircle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #d1d5db;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.stepItem.completed .stepCircle {\n  background: #10b981;\n}\n\n.stepContent {\n  flex: 1;\n}\n\n.stepLabel {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.stepDate {\n  font-size: 0.85rem;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n.timeline {\n  position: relative;\n  padding-left: 32px;\n}\n\n.timeline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 14px;\n  width: 4px;\n  background: #e5e7eb;\n}\n\n.timelineItem {\n  position: relative;\n  margin-bottom: 28px;\n}\n\n.timelineDot {\n  position: absolute;\n  left: -32px;\n  top: 6px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #3b82f6;\n  border: 4px solid #bfdbfe;\n}\n\n.timelineContent {\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border-left: 4px solid #3b82f6;\n}\n\n.timelineAction {\n  font-weight: 600;\n  color: #1e40af;\n  margin-bottom: 8px;\n}\n\n.timelineRemark {\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.timelineMeta {\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.loading,\n.error,\n.noData {\n  text-align: center;\n  padding: 40px 0;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.error {\n  color: #dc2626;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LeadProgressBar_container__zGu4L`,
	"header": `LeadProgressBar_header__I8H1d`,
	"title": `LeadProgressBar_title__ZFY9f`,
	"currentStage": `LeadProgressBar_currentStage__n+P-a`,
	"lastActivity": `LeadProgressBar_lastActivity__XeVa+`,
	"progressSection": `LeadProgressBar_progressSection__j3+jd`,
	"progressBarWrapper": `LeadProgressBar_progressBarWrapper__0nwfY`,
	"progressBar": `LeadProgressBar_progressBar__BPONC`,
	"progressFill": `LeadProgressBar_progressFill__SkEHR`,
	"progressText": `LeadProgressBar_progressText__64YYB`,
	"progressLabel": `LeadProgressBar_progressLabel__P5s0K`,
	"sectionTitle": `LeadProgressBar_sectionTitle__qfHIk`,
	"stepsList": `LeadProgressBar_stepsList__n+Kn7`,
	"stepItem": `LeadProgressBar_stepItem__XwJRd`,
	"completed": `LeadProgressBar_completed__JIYCv`,
	"stepCircle": `LeadProgressBar_stepCircle__zi3Gr`,
	"stepContent": `LeadProgressBar_stepContent__bL2qx`,
	"stepLabel": `LeadProgressBar_stepLabel__Gt-35`,
	"stepDate": `LeadProgressBar_stepDate__6yAKk`,
	"timeline": `LeadProgressBar_timeline__iHGZW`,
	"timelineItem": `LeadProgressBar_timelineItem__4hmyU`,
	"timelineDot": `LeadProgressBar_timelineDot__o7kBM`,
	"timelineContent": `LeadProgressBar_timelineContent__0F-CI`,
	"timelineAction": `LeadProgressBar_timelineAction__2aR0D`,
	"timelineRemark": `LeadProgressBar_timelineRemark__zXkqo`,
	"timelineMeta": `LeadProgressBar_timelineMeta__BmCZ-`,
	"loading": `LeadProgressBar_loading__PsmxU`,
	"error": `LeadProgressBar_error__ySGlQ`,
	"noData": `LeadProgressBar_noData__7QR9B`
};
export default ___CSS_LOADER_EXPORT___;
